import { JugglingScreen } from "@motleyhand/design"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/juggling")({
  component: RouteComponent,
})

function RouteComponent() {
  return <JugglingScreen />
}
